<template>
  <el-dialog
    :visible.sync="visible"
    custom-class="ad-popup-dialog"
    :show-close="false"
    width="500px"
    append-to-body
    center
  >
    <div v-if="ad" class="ad-popup-content">
      <div class="ad-image" @click="handleAdClick">
        <img :src="ad.adImage" :alt="ad.adTitle">
      </div>
      <div class="ad-close" @click.stop="close">
        <i class="el-icon-circle-close"></i>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { addAdvertisementView } from '@/api/courseApi'

export default {
  name: 'AdPopup',
  props: {
    ad: {
      type: Object,
      required: true
    },
    pageId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      visible: false
    }
  },
  watch: {
    ad: {
      handler(newVal) {
        if (newVal) {
          this.checkAndShow()
        }
      },
      immediate: true
    }
  },
  methods: {
    checkAndShow() {
      if (!this.ad) return
      this.visible = true
    },
    handleAdClick() {
      if (!this.ad) return
      
      if (this.ad.id) {
        addAdvertisementView(this.ad.id).catch(e => console.error(e))
      }
      
      const url = this.sanitizeUrl(this.ad.adLink)
      if (url) {
        window.open(url, '_blank', 'noopener')
      }
      
      // Close after click
      this.visible = false
    },
    close() {
      this.visible = false
    },
    sanitizeUrl(url) {
      const raw = String(url || '').trim()
      if (!raw) return ''
      return raw.replace(/`/g, '').trim()
    }
  }
}
</script>

<style lang="scss">
.ad-popup-dialog {
  background: transparent !important;
  box-shadow: none !important;
  
  .el-dialog__header {
    display: none;
  }
  
  .el-dialog__body {
    padding: 0;
    background: transparent;
  }
}
</style>

<style scoped>
.ad-popup-content {
  position: relative;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
}
.ad-popup-content img {
  width: 100%;
  display: block;
}
.ad-close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  color: #fff;
  cursor: pointer;
  z-index: 100;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s;
}
.ad-close:hover {
  background: rgba(0, 0, 0, 0.6);
}
</style>
